import { styled } from '@mui/material';
import { useAtom, useSetAtom } from 'jotai';
import { FC, useEffect } from 'react';
import { useDebouncedValue } from '../../../../hooks/useDebouncedValue';
import { useUpdateReport, useUpdateReportWithToken } from '../../../../queries/useReports';
import { activeReportState, responsesState } from '../../../../state/UIState';
import { QuestionnaireMainContent } from './QuestionnaireMainContent';
import { QuestionnaireSideSection } from './QuestionnaireSideSection';
import { internalSurveyState } from '../../../../state/internalSurveyState';
import { REPORT_STATUS } from '../../../../types';

const Wrapper = styled('div')`
  display: flex;
  height: 100%;
`;

interface QuestionnaireStepProps {
  isInternal?: boolean;
  isReview?: boolean;
  isPortal?: boolean;
  withFooter?: boolean;
}

export const QuestionnaireStep: FC<QuestionnaireStepProps> = ({
  isInternal = false,
  isReview = false,
  withFooter = false,
  isPortal = false,
}) => {
  const [response] = useAtom(responsesState);
  const [report] = useAtom(activeReportState);
  const debouncedResponse = useDebouncedValue(response, 500);
  const updateReport = useUpdateReport();
  const updateReportWithToken = useUpdateReportWithToken();

  const setInternalSurvey = useSetAtom(internalSurveyState);

  useEffect(() => {
    setInternalSurvey(isInternal);
  }, [isInternal, setInternalSurvey]);

  useEffect(() => {
    if (response && report && !isReview) {
      if (isInternal || isPortal) {
        updateReport.mutate({
          id: report.id,
          response: debouncedResponse,
        });
      } else {
        updateReportWithToken.mutate({
          response: debouncedResponse,
          status: REPORT_STATUS.IN_PROGRESS,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedResponse]);

  return (
    <Wrapper>
      <QuestionnaireSideSection />
      <QuestionnaireMainContent withFooter={withFooter} />
    </Wrapper>
  );
};
